import type { IconData } from '@stacksjs/iconify-core'

export const lightningCloud: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M43.607 29.5C44.5 27.938 45 26.082 45 24c0-5.367-3.314-9.23-8.178-10.435C35.892 7.38 31.39 3.05 24.777 3.003a110 110 0 0 0-1.554 0c-6.614.047-11.116 4.378-12.045 10.562C6.314 14.77 3 18.633 3 24c0 6.328 4.607 10.565 10.93 10.82q.975.04 2.07.072\"/><path d=\"M36.9 24.887c.396-1.307-.48-2.582-1.841-2.707A45 45 0 0 0 31 22c-2.022 0-3.534.128-4.534.254c-.93.118-1.688.751-2.036 1.623c-1.34 3.365-2.286 6.598-2.84 8.703c-.326 1.237.624 2.41 1.904 2.407c1.008-.001 2.234.001 3.506.013c0 0-.776 4.071-1.551 8.432c-.16.903.866 1.508 1.563.913c4.371-3.736 8.567-8.196 11.203-11.14c1.13-1.26.226-3.205-1.467-3.205H35s1.111-2.516 1.9-5.113\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default lightningCloud
